import type { CardCarouselProps } from '@time-line/components/common';
import { CardCarousel } from '@time-line/components/common';
import { BlogCard } from 'components/blog/BlogCard';
import { usePosts } from 'hooks/usePosts';
import { BLOG } from 'lib/constants/routes';
import NextLink from 'next/link';
import type { BlogCarousel } from 'types/cms/blocks';

type BlogCardCarouselProps = Omit<CardCarouselProps, 'children'> &
  Pick<BlogCarousel, 'title' | 'category' | 'ctaLabel'>;

export function BlogCardCarousel({
  title,
  category,
  ctaLabel,
  ...props
}: BlogCardCarouselProps) {
  const { data: postsData } = usePosts({
    count: 5,
    category: category === 'all' || !category ? null : category,
  });

  if (!postsData) return null;

  const cardCarouselProps = {
    title,
    cta: {
      title: ctaLabel,
      href: BLOG,
      as: NextLink,
    },
    ...props,
  };

  return (
    <CardCarousel
      className="section--blog-card-carousel"
      buttonVerticalOffset="39%"
      {...cardCarouselProps}
    >
      {postsData.posts.map((post, i) => (
        <BlogCard
          className={`blog-card-${i + 1}`}
          key={post._id}
          type={post.type}
          title={post.title}
          image={post.heroImage}
          videoUrl={post.heroVideoUrl}
          slug={post.slug}
          categories={post.categories}
          publishedAt={post.publishedAt}
        />
      ))}
    </CardCarousel>
  );
}
